import { render } from "./OrcamentoPendenteInformacao.vue?vue&type=template&id=3ed4dc71&scoped=true"
import script from "./OrcamentoPendenteInformacao.vue?vue&type=script&lang=js"
export * from "./OrcamentoPendenteInformacao.vue?vue&type=script&lang=js"

import "./OrcamentoPendenteInformacao.vue?vue&type=style&index=0&id=3ed4dc71&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed4dc71"]])

export default __exports__